import { genKey, getStorage, removeStorage, setStorage } from "components/utils/Storage";
import { ERROR_REFRESH_TOKEN, LOGIN, LOGOUT, UPDATE_TOKEN } from "../constants/constants";

const initialState = {
  user: getStorage(genKey("user")),
  token: getStorage(genKey("token")),
  profil: getStorage(genKey("profil")),
  authenticated: null,
};

const AuthentificationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case LOGIN:

      // Remplissage du localStorage
      setStorage(genKey("user"), action.payload.user);
      setStorage(genKey("token"), action.payload.token);
      setStorage(genKey("profil"), action.payload.profil);

      // Màj du state
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        profil: action.payload.profil,
        authenticated: action.payload.authenticated
      };
    case LOGOUT:

      // Vidage du localStorage
      removeStorage(genKey("user"));
      removeStorage(genKey("token"));
      removeStorage(genKey("profil"));

      // Màj du state
      return {
        ...state,
        user: null,
        token: null,
        profil: null,
        authenticated: false,
      };
    case UPDATE_TOKEN:
      setStorage(genKey("token"), action.payload.token);
      return {
        ...state,
        token: action.payload.token,
        authenticated: true
      };
    case ERROR_REFRESH_TOKEN:
      return {
        ...state,
        token: null,
        authenticated: false,
      }
    default:
      return state;
  }
};

export default AuthentificationReducer;
